import React, { useContext, useState } from 'react'
import * as R from 'ramda'
import styled, { ThemeProvider } from 'styled-components'
import Modal from 'react-modal'
import ButtonToogle from '../../components/ButtonTootle'
import IconClose from '../../assets/images/icon-close.png'
import InputCode from '../../components/InputCode'
import { constants } from '../../constants/SectionHomeReponsive'

import { AppContext } from '../../store'

const pickColor = (option) => R.path(['theme', `color_${option}`])

const Container = styled.div`
  .section-home-container div.title-container {
    color: ${pickColor('label_on_primary')};
  }
  .btn.secondary {
    background: ${pickColor('button')};
    color: ${pickColor('button_label')};
  }
  .text-container {
    color: ${pickColor('primary')};
  }

  .text-secondary {
    color: ${pickColor('default')};
  }

  .section-home-container.gray {
    background: ${pickColor('secondary')};
  }

  .section-home-container.pt0 {
    background: ${pickColor('primary')};
    padding-top: 20px;
    .text-initial {
      color: ${pickColor('label_on_primary')};
    }
  }

  .infomations,
  .plans-container,
  .code-input-container {
    .btn.secondary {
      background: ${pickColor('default')};
      color: #fff;
    }
  }

  .btn-toogle {
    background: ${pickColor('primary')};
    color: ${pickColor('label_on_primary')};
  }
`

export default function SectionHomeReponsive() {
  const { state, openPromotion } = useContext(AppContext)
  const { isHUB, ready, regulamento, contentful } = state
  const { team: { fields = {} } = {} } = contentful || {}

  const [modalIsOpen, setModalIsOpen] = useState(false)

  const toPlans = () => {
    document.getElementById('home').scrollIntoView()
  }

  const showModalTerm = () => {
    document.body.style.overflow = 'hidden'
    setModalIsOpen(!modalIsOpen)
  }

  const closeModalTerm = () => {
    document.body.style.overflow = 'auto'
    setModalIsOpen(false)
  }

  const customStyles = {
    content: {},
  }

  return (
    <ThemeProvider theme={fields}>
      <Container>
        <section className='section-home-container pt0'>
          <div className='f24 bold text-initial mb15'>
            <strong>{fields.panel_primary_call_title}</strong>
          </div>
          <div className='f12 text-initial'>{fields.panel_primary_call_description}</div>
          <div className='cta-container'>
            <button className='btn secondary cta' onClick={toPlans}>
              {fields.panel_primary_call_button_label}
            </button>
          </div>
        </section>

        {isHUB && !ready && (
          <div id='home'>
            <InputCode />
          </div>
        )}

        {ready && (
          <>
            <section id='home' className='section-home-container text-center pb0'>
              <div className='container-text'>
                <div className='car-image'>
                  <img src={fields.painel_plan_image?.fields?.file?.url} alt='car' />
                </div>
                <span className='tc'>{fields.painel_plan_title}</span>
              </div>
            </section>

            <section className='infomations'>
              <ButtonToogle
                information={constants[0]}
                openModal={showModalTerm}
                promotion={openPromotion('PRE')}
                className='secondary'
              />
              <ButtonToogle
                information={constants[1]}
                openModal={showModalTerm}
                promotion={openPromotion('POS')}
                className='secondary'
              />
            </section>
          </>
        )}

        <Modal isOpen={modalIsOpen} onRequestClose={closeModalTerm} style={customStyles} contentLabel='Example Modal'>
          <div className='modal'>
            <div className='modal-header'>
              <button className='btn-close' onClick={closeModalTerm}>
                <img alt='Icon Close' src={IconClose} />
              </button>
            </div>
            <div className='title' style={{ textAlign: 'center', marginTop: 30 }}>
              <h4>{regulamento.title.toUpperCase()}</h4>
            </div>
            <div className='modal-container calibri' dangerouslySetInnerHTML={{ __html: regulamento.content }} />
          </div>
        </Modal>
      </Container>
    </ThemeProvider>
  )
}
